import React from 'react'
import { isFlagOn, getShapeBorderStyle, getLineShapeStyle, resolveTextStyle, resolveTableCellStyle, tableCellCss } from '../../lib/global/helpers'

export default function HTMLTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderImage = (section) => {
        return props.properties.head.logo.showLogo &&
            props.properties.head.logo.logo !== null ? (
            <div
                style={props.properties.head.logo.style}
                key={props.properties.head.logo.id || 'logo'}
                data-element={props.properties.head.logo.name || 'logo'}
                data-section={section}
                data-path="logo"
                data-index=""
            >
                <div>
                    <img
                        src={props.tempLogo ? props.tempLogo : props.properties.head.logo.logo}
                        style={{
                            width:
                                (props.properties
                                    ? props.properties.head.logo.logoSize
                                    : 100) + "%",
                            pointerEvents: "none",
                        }}
                        alt="Company Logo"
                    />
                </div>
            </div>
        ) : (
            <></>
        );
    };

    const renderUploadedImages = (section) => {
        const images = props.properties?.[section]?.images;
        if (!images) return null;

        return Object.keys(images).map((key) => {
            const data = images[key];
            if (!data || !data.src) return null;

            return (
                <div
                    key={data.id || key}
                    style={data.style}
                    id={data.id}
                    data-element={data.name}
                    data-section={section}
                    data-path="images"
                    data-index={key}
                >
                    <img
                        src={data.src}
                        alt={data.alt || data.name || ''}
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </div>
            );
        });
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                dStyle = resolveTextStyle(dStyle, props.properties[section]?.font, props.properties.prop);

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={dStyle}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderVatSummary = () => {
        if (props.properties?.total?.VatSummary &&
            Object.keys(props.properties.total.VatSummary).length > 0) {
            var data = props.properties.total.VatSummary;
            var dStyle = Object.assign({}, data.style || {});
            dStyle = resolveTextStyle(dStyle, props.properties.total?.font, props.properties.prop);

            const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || 'vat-summary');

            return (
                <div
                    key={data.id || 'vat-summary'}
                    style={dStyle}
                    id={data.id}
                    data-element={data.name || 'VatSummary'}
                    data-section="VatSummary"
                    data-path="elements"
                    data-index={dataIndex}
                >
                    {data.text || ''}
                </div>
            );
        }
        return null;
    };

    const renderShapes = (section) => {
        if (!props.properties[section]?.shapes) return null;

        return Object.keys(props.properties[section].shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties[section].shapes[key];
                if (!prop) return null;

                var sectionBorder = props.properties[section].shapes.border || {};
                var isLine = prop.name && prop.name.startsWith('line');
                var bgColor = prop.fillColor || sectionBorder.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign(isLine ? {} : { minWidth: '32px', minHeight: '16px' }, prop.style || {});
                if (isLine) {
                    Object.assign(dStyle, getLineShapeStyle(prop, sectionBorder));
                } else {
                    Object.assign(dStyle, getShapeBorderStyle(prop, sectionBorder));
                    dStyle.background = bgColor;
                }
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={section}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    const renderCompanyElements = () => {
        if (!props.properties.head.companyProps) return null;

        return Object.keys(props.properties.head.companyProps).map((key) => {
            var prop = props.properties.head.companyProps[key];
            if (!prop || !prop.show) return null;

            var dStyle = Object.assign({}, prop.style || {});
            dStyle = resolveTextStyle(dStyle, props.properties.head?.font, props.properties.prop);

            return (
                <div
                    key={key}
                    style={dStyle}
                    id={prop.id}
                    data-element={prop.name || 'company-prop'}
                    data-section={"head"}
                    data-path="companyProps"
                    data-index={prop.data || key}
                >
                    {prop.text || ''}
                </div>
            );
        });
    };

    const renderDocumentTitle = () => {
        var title = props.properties.head.documentTitle;
        if (!title || !title.show) return null;

        var dStyle = Object.assign({}, title.style || {});
        dStyle = resolveTextStyle(dStyle, props.properties.head?.font, props.properties.prop, { defaultFontSize: "20pt", ignoreSectionColor: true });

        return (
            <div
                style={dStyle}
                key={title.id || 'doc-title'}
                id={title.id}
                data-element={title.name || 'document-title'}
                data-section={"head"}
                data-path="documentTitle"
                data-index={title.title || 'title'}
            >
                {title.title || 'INVOICE'}
            </div>
        );
    };

    const renderBodyElements = (displayData) => {
        const tableHeader = props.properties.items.layout.tableHeader;
        return (
            <table
                style={{
                    marginLeft: props.properties.prop.margin?.left + 'in' || '0.5in',
                    marginRight: props.properties.prop.margin?.right + 'in' || '0.5in',
                    width: 'calc(100% - 1in)'
                }}
                cellSpacing={0}
                className="items-table"
            >
                <thead style={{ display: 'table-header-group' }}>
                    <tr>
                        {displayData.map((obj, key) => {
                            if (obj) {
                                const totalWidth = displayData.reduce((a, v) => a + Number(v?.width || 10), 0);
                                return (
                                    <th
                                        key={`dd_${key}`}
                                        width={obj.width ? (obj.width / totalWidth) * 100 + "%" : 'auto'}
                                        style={{
                                            padding: "10px 0px 10px 10px",
                                            ...tableCellCss(resolveTableCellStyle(props.properties.items.layout, obj, "header")),
                                        }}
                                    >
                                        {obj.header}
                                    </th>
                                );
                            }
                            return null;
                        })}
                    </tr>
                    {tableHeader.showBottomBorder && (
                        <tr>
                            <th colSpan={displayData.length} style={{ padding: 0 }}>
                                <div style={{
                                    width: `${tableHeader.bottomBorderWidth ?? 100}%`,
                                    height: `${tableHeader.bottomBorderSize ?? 1}px`,
                                    backgroundColor: tableHeader.bottomBorderColor || '#333333ff'
                                }} />
                            </th>
                        </tr>
                    )}
                </thead>
                {'{TableBodyContent}'}
            </table>
        );
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: props.properties.prop.orientation === "landscape" ? '1132px' : '800px',
            minHeight: '400px',
            backgroundColor: props.properties.prop.background.showColor
                ? props.properties.prop.background.color
                : "transparent",
        }}>
            <div>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>
                                <div style={{
                                    height: props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.height
                                }}>
                                    <div>
                                        {renderElements("head")}
                                        {renderImage("head")}
                                        {renderDocumentTitle()}
                                        {renderCompanyElements()}
                                        {renderShapes("head")}
                                        {renderUploadedImages("head")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="items_table_conteiner" data-layout="items-grow">
                                    {renderBodyElements(
                                        Object.keys(props.properties.items.items)
                                            .map(key => props.properties.items.items[key])
                                            .filter(d => d && d.width !== undefined)
                                    )}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div
                                    style={{
                                        height: props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                                        position: 'relative',
                                        pageBreakInside: 'avoid',
                                        breakInside: 'avoid',
                                        backgroundColor: props.properties.total.background.showColor
                                            ? props.properties.total.background.color
                                            : "transparent",
                                    }}
                                    className='total-section'
                                    data-layout={props.properties.total?.position === "aboveFooter" ? "total-above-footer" : "total-after-items"}
                                    data-total-position={props.properties.total?.position === "aboveFooter" ? "aboveFooter" : "afterItems"}
                                >
                                    <div>
                                        {renderElements("total")}
                                        {renderVatSummary()}
                                        {renderShapes("total")}
                                        {renderUploadedImages("total")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div
                                    style={{
                                        height: props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                                        position: 'relative',
                                        pageBreakInside: 'avoid',
                                        breakInside: 'avoid',
                                        backgroundColor: props.properties.foot.background.showColor
                                            ? props.properties.foot.background.color
                                            : "transparent",
                                    }}
                                    className='foot-section'
                                    data-layout="footer-bottom-of-last-page"
                                    data-print-every-page={isFlagOn(props.properties.foot?.printingFooterEveryPage) ? "true" : "false"}
                                >
                                    <div>
                                        {renderElements("foot")}
                                        {renderShapes("foot")}
                                        {renderUploadedImages("foot")}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}